import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=2d4c2bb6&scoped=true&"
import script from "./CancelOrder.vue?vue&type=script&lang=js&"
export * from "./CancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=2d4c2bb6&lang=scss&scoped=true&"
import style1 from "./CancelOrder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c2bb6",
  null
  
)

export default component.exports